import styled from '@emotion/styled';

const SubTitle = styled('p')(({ theme }) => ({
  color: theme.colors.gray.medium,
  fontSize: '1.3rem',
  lineHeight: '1.755rem',
}));

export default SubTitle;
